<!-- not for loyalty -->
<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogVisible"
      persistent
      max-width="900px"
    >
      <base-material-card
        color="primary"
        icon="mdi-filter-outline"
        inline
        class="filter_popup"
      >
        <v-card-title>
          <span class="text-h5">Фильтры</span>
        </v-card-title>
        <v-card-text>
          <v-tabs
            v-model="tabIndex"
          >
            <v-tab
              v-for="(tab, index) in filterFields"
              :key="index"
            >
              <div class="filter_row">
                {{ tab.name }}
<!--                <v-btn-->
<!--                  icon-->
<!--                >-->
<!--                  <v-icon-->
<!--                    left-->
<!--                    :class="[{'active': $store.state.user.tab_place === tab.index}]"-->
<!--                  >-->
<!--                    mdi-star-->
<!--                  </v-icon>-->
<!--                </v-btn>-->
              </div>
            </v-tab>

            <v-tab-item
              v-for="(tab, index) in filterFields"
              :key="index"
            >
              <v-card flat>
                <v-card-text>
                  <div
                    v-for="(field, index2) in tab.data"
                    :key="'i_'+index2"
                  >
                    <v-autocomplete
                      v-if="field.type==='autocomplete'"
                      v-model="field.value"
                      clearable
                      :label="field.name"
                      :items="field.select"
                      @change="filter.changed = true"
                    />
                    <v-select
                      v-if="field.type==='select'"
                      v-model="field.value"
                      clearable
                      :label="field.name"
                      :items="field.select"
                      @change="filter.changed = true"
                    />
                    <div
                      v-else-if="field.type==='date'"
                      clearable
                      :label="field.name"
                      :items="field.select"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="field.date_select"
                            clearable
                            :label="field.name"
                            :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                            @change="onChangeFilterDateType($event, index , field)"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="field.from"
                            :label="field.date_select === 'period' ? 'От' : 'Конкретная дата'"
                            :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                            type="date"
                            :max="maxDate"
                            @input="filter.changed = true"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-if="field.date_select === 'period'"
                            v-model="field.to"
                            label="До"
                            type="date"
                            :max="maxDate"
                            @input="filter.changed = true"
                          />
                        </v-col>
                      </v-row>
                    </div>
                    <v-text-field
                      v-if="field.type==='text'"
                      v-model="field.value"
                      :label="field.name"
                      :type="field.type"
                      @input="filter.changed = true"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            width="80"
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2 btn-hi-primary"
            @click="onSetFilter"
          >
            <span class="mx-10">Применить</span>
          </v-btn>
          <v-btn
            width="80"
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2 btn-hi-secondary"
            @click="onClose"
          >
            <span class="mx-10">Закрыть</span>
          </v-btn>
        </v-card-actions>
      </base-material-card>
    </v-dialog>
  </v-row>
</template>

<script>

import moment from "moment/moment"

export default {
    name: "JustpayFilterDialog",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        filterLabel: {
            type: String,
            default: "filter"
        },
        filterFields: {
            type: null
        }
    },
    data: () => ({
      filter: {
        set: false
      },
      tabIndex: 0
    }),
  computed: {
    maxDate: function () {
      return moment().format('YYYY-MM-DD')
    },
  },
    methods: {
      formatInputDate: function (_date) {
        const date = new Date(_date)
        let dd = date.getDate()
        if (dd < 10) dd = '0' + dd

        let mm = date.getMonth() + 1
        if (mm < 10) mm = '0' + mm

        let yyyy = date.getFullYear()
        if (yyyy < 10) yyyy = '0' + yyyy

        return yyyy + '-' + mm + '-' + dd
      },
      onChangeFilterDateType (value, tab, field) {
        this.filter.changed = true
        console.log('changeFilterDateType', value, tab, field)
        if (tab && field && value) {
          if (value !== 'period' && value !== 'date') {
            let date = 0
            if (value === 'today') {
              date = new Date()
            } else if (value === 'yesterday') {
              date = new Date().setDate(new Date().getDate() - 1)
            } else if (value === 'tomorrow') {
              date = new Date().setDate(new Date().getDate() + 1)
            }
            const formated_date = this.formatInputDate(date)
            field.from = formated_date
            field.to = formated_date
          }
          if (value === 'date') {
            field.to = ''
          }
        }
      },

        onClose () {
            this.$emit("close")
        },
        onInputDate (index) {
            console.log('newDate', index)
            this.dateMenuFrom = false
            this.dateMenuTo = false
        },
      onSetFilter () {
        this.$emit('change', this.filterFields)
      }
    }
}
</script>

<style scoped>

</style>
